import React from 'react';
import classes from './CheckBox.module.scss';
import WithWrapper from '../withWrapper/WithWrapper';

const CheckBox = props => (
  <label
    className={`${classes.checkBox + (!!props.errormsg ? ' ' + classes.checkBoxError : '')} ${
      classes.checkBoxContainer
    }`}
  >
    <input
      name={props.name}
      type="checkbox"
      value={props.value}
      checked={props.checked}
      onChange={e => props.onChange(e, props.value)}
    />
    <span className={`${classes.markContainer} ${classes.checkBoxPosition}`}>
      <span className={`${classes.mark}`}></span>
    </span>
    {props.inputLabel.map((value, index) => (
      <span key={index} className={classes.innerText}>
        {value}
      </span>
    ))}
  </label>
);
export default WithWrapper('checkbox')(CheckBox);
